import Stepper from "./components/Stepper";
import React from "react";
import StepContent from "./components/StepContent";
import { withStyles } from "@material-ui/core";
import { format } from "date-fns";
import { getInitialStepData, redirectToIBPlanning } from "./utils";
import { APP_DATE_FORMAT } from "./constants";
import { getDataWithQueryString, postData } from "./../../../api/componentAPIs";
import { compose } from "recompose";
import { withUserProfile } from "../../../userProfile/userProfileContext";
import { withSnackbar } from "notistack";
import { PlanDateContext } from './PlanDateContext';
import { WithShipmentSelectionHOC } from "./WithShipmentSelectionHOC";
const styles = () => ({
  container: {
    paddingTop: 16,
    display: "flex",
    flexDirection: "column",
    height: "calc(100% - 16px)",
  },
});
class ShipmentSelection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeStep: 0,
      stepData: getInitialStepData(),
      planDate: null,
      serviceLevelList: [],
      startDate: null,
    };
  }

  componentDidMount() {
    this.populateClientCodesData();
  }

  populateClientCodesData = () => {
    getDataWithQueryString("GetClientCodes").then((response) => {
      if (response && response.status === 200) {
        this.setState({
          serviceLevelList: response.data.serviceLevelList,
        });
      } else {
        this.setState({
          serviceLevelList: [],
        });
      }
    });
  };

  goToNextStep = (selectedShipmentIds) => {
    const { activeStep } = this.state;
    this.setState((prevState) => ({
      activeStep: prevState.activeStep + 1,
      stepData: {
        ...prevState.stepData,
        [activeStep]: selectedShipmentIds,
      },
    }));
  };

  goBack = () => {
    this.setState((prevState) => ({
      activeStep: prevState.activeStep - 1,
    }));
  };

  handleSubmit = (lastStepPros) => {
    const selectedShipments = Object.values(this.state.stepData).reduce(
      (acc, value) => {
        return [...acc, ...value];
      },
      [...lastStepPros]
    );
    const reqData = {
      pros: selectedShipments,
      planDate: format(this.state.planDate, APP_DATE_FORMAT),
      terminalId: this.props.userData.userProfile.terminal.id,
      startDate: this.state.startDate ? format(this.state.startDate, APP_DATE_FORMAT) : undefined
    };
    postData("AddShipmentsToPlan", reqData).then(
      (response) => {
        if (response?.status === 200) {
          redirectToIBPlanning();
        } else {
          this.props.enqueueSnackbar("Adding shipments to plan failed", {
            variant: "error",
          });
        }
      },
      (_error) => {
        this.props.enqueueSnackbar("Adding shipments to plan failed", {
          variant: "error",
        });
      }
    );
  };

  handlePlanDateChanged = (planDate, startDate = null) => {
    const activeStep = this.props.showDateRange
      ? this.state.activeStep
      : this.state.activeStep + 1;
    this.setState(
      (_prevState) => ({
        planDate,
        activeStep,
        startDate,
      }),
      () => {
        this.props.showDateRange && this.handleSubmit([]);
      }
    );
  };

  render() {
    const { classes, showDateRange, steps } = this.props;
    const planDate = this.state.planDate
      ? format(this.state.planDate, APP_DATE_FORMAT)
      : null;
    const startDate = this.state.startDate
      ? format(this.state.startDate, APP_DATE_FORMAT)
      : null;
    return (
      <div className={classes.container}>
        <Stepper activeStep={this.state.activeStep} steps={steps} />
        <PlanDateContext.Provider value={{ planDate, startDate }}>
          <StepContent
            step={this.state.activeStep}
            goToNextStep={this.goToNextStep}
            handlePlanDateChanged={this.handlePlanDateChanged}
            glEventHub={this.props.glEventHub}
            goBack={this.goBack}
            selectedShipmentIds={this.state.stepData[this.state.activeStep]}
            handleSubmit={this.handleSubmit}
            isLastStep={steps.length - 1 === this.state.activeStep}
            serviceLevelList={this.state.serviceLevelList}
            showDateRange={showDateRange}
            steps={steps}
          />
        </PlanDateContext.Provider>
      </div>
    );
  }
}

export default compose(
  withUserProfile,
  withSnackbar,
  WithShipmentSelectionHOC,
  withStyles(styles)
)(ShipmentSelection);
